import { useEffect, useState } from 'react';
import { MEASUREMENT_PANEL_WIDTH, MAP_BTNS_DEFAULT_BOTTOM } from '../Constants/Constant';

// Defines breakpoints for different device screen sizes
export const BREAKPOINTS = { sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 };

/**
 * @name getBreakpoint
 * @function
 * @description calculate device current breakpoint
 * @returns {String} Example, If window's width is greater than BREAKPOINTS.xxl then return xxl
 */
export const getBreakpoint = () => {
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.xxl}px)`).matches) return 'xxl';
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.xl}px)`).matches) return 'xl';
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`).matches) return 'lg';
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.md}px)`).matches) return 'md';
  return 'sm';
};

/**
 * @name useBreakpoint
 * @function
 * @description A hook used to listen on device screen size change
 * and changes its value when breakpoint changed
 */
export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    // Window resize listener
    const onResize = () => {
      // Refresh breakpoint
      setBreakpoint(getBreakpoint);
    };

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return breakpoint;
};

// Renders the map buttons on the output screen
export const renderMapButtons = ({ mobileView, collapsed, fullscreen }: $TSFixMe) => {
  // If the mobile view is collapsed or fullscreen
  if (mobileView && (collapsed || fullscreen)) {
    setTimeout(() => {
      const panel = document.querySelector('.output-timeline.detail');
      // Determine the bottom position of the map buttons.
      let bottom;

      if (fullscreen) {
        bottom = 15;
      } else if (panel) {
        bottom = document.body.clientHeight - panel.getBoundingClientRect().top;
      } else {
        bottom = MAP_BTNS_DEFAULT_BOTTOM;
      }

      // If the bottom position is greater than 300, set it to the default value.
      if (bottom > 300) bottom = MAP_BTNS_DEFAULT_BOTTOM;

      // Get reference to different buttons to be positioned.
      const leftBtns = document.querySelector('.map-custom-btns') as HTMLElement;
      const fullscreenBtn = document.querySelector('.map-fullscreen-btn') as HTMLElement;
      const mapBtns = document.querySelector('.ol-zoom.ol-control') as HTMLElement;
      const reorientBtn = document.querySelector('.ol-rotate-reset') as HTMLElement;

      // If the HD imagery and satelite view buttons exists, then position them to the left.
      if (leftBtns) {
        leftBtns.style.bottom = `${bottom + 10}px`;
        leftBtns.style.left = `10px`;
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.bottom = `${bottom + 130}px`;
        fullscreenBtn.style.left = `10px`;
      }

      // If the zoom control buttons exist, then position them.
      if (mapBtns) mapBtns.style.bottom = `${bottom + 10}px`;

      // If reorientation button exist, then position it.
      if (reorientBtn) {
        reorientBtn.style.bottom = `${bottom + 10}px`;
        reorientBtn.style.right = `75px`;
      }
    }, 500);
  }
  // If user is not in mobile view.
  else if (!mobileView) {
    const bottom = 10;
    const mapBtnBottom = 110;

    // MEASUREMENT_PANEL_WIDTH represents the side panel width
    // If sidepanel is not collapsed then it is taken into the consideration else it won't
    const left = collapsed ? 20 : MEASUREMENT_PANEL_WIDTH + 20;

    // Get reference to different buttons to be positioned.
    const leftBtns = document.querySelector('.map-custom-btns') as HTMLElement;
    const fullscreenBtn = document.querySelector('.map-fullscreen-btn') as HTMLElement;
    const mapBtns = document.querySelector('.ol-zoom.ol-control') as HTMLElement;
    const reorientBtn = document.querySelector('.ol-rotate-reset') as HTMLElement;

    // If the HD imagery and satelite view buttons exists, then position them to the left.
    if (leftBtns) {
      leftBtns.style.bottom = `${bottom}px`;
      leftBtns.style.left = `${left}px`;
    }

    if (fullscreenBtn) {
      fullscreenBtn.style.bottom = `${bottom + 85}px`;
      fullscreenBtn.style.left = `${left}px`;
    }

    // If the zoom control buttons exist, then position them.
    if (mapBtns) mapBtns.style.bottom = `${mapBtnBottom}px`;

    // If reorientation button exist, then position it.
    if (reorientBtn) {
      reorientBtn.style.bottom = `${bottom}px`;
      reorientBtn.style.right = `230px`;
    }
  }
};

// It manages toolbar sidepanel(s) padding when toolbar is resized or hidden.
// export const onToolbarResize = (mobileView, toolbarHidden = true) => {
//     // Remove top padding If toolbar is hidden or it is a mobileview
//     if (mobileView || !toolbarHidden) {
//         const sidepanelNode = document.querySelector('.output-timeline');
//         const fileSidePanelNode = document.querySelector('.file-side-panel');
//         if (sidepanelNode) sidepanelNode.style.paddingTop = '';
//         if (fileSidePanelNode) fileSidePanelNode.style.paddingTop = '';
//         return;
//     }

//     // If reference to toolbar is not available then do nothing.
//     const toolbar = document.querySelector('.toolbar');
//     if (!toolbar) return;

//     const resizeObserver = new ResizeObserver(entries => {
//         const sidepanelNode = document.querySelector('.output-timeline');
//         const fileSidePanelNode = document.querySelector('.file-side-panel');
//         for (let entry of entries) {
//             // if (sidepanelNode) sidepanelNode.style.paddingTop = entry.contentRect.height + 10 + 'px';
//             // if (fileSidePanelNode) fileSidePanelNode.style.paddingTop = entry.contentRect.height + 20 + 'px';
//         }
//     });

//     resizeObserver.observe(toolbar);
//     return resizeObserver;
// };
